import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import '../../assets/css/yearpicker.css'

export default function ReactYearPicker({
  value,
  onChange,
  hasErrors,
  placeholder,
  disabled,
  dateFormat,
  showMonthDropdown,
  showYearDropdown,
  minDate,
  maxDate,
  startDate,
  endDate,
  isClearable,
  selectsRange,
  formFieldsDisabled,
  portalId = "root-portal"
}) {
  const isDisabled = formFieldsDisabled;

  const renderYearContent = (year) => {
    const tooltipText = `Tooltip for year: ${year}`;
    return <span title={tooltipText}>{year}</span>;
  };


  return (
    <div className="position-relative yearpicker" >
      <DatePicker
        value={value}
        selected={value}
        renderYearContent={renderYearContent}
      showYearPicker
        onChange={e => onChange(e)}
        formatWeekDay={day => day.slice(0, 3)}
        dateFormat={dateFormat}
        className={`form-control col-12 ${hasErrors && 'is-invalid'}`}
        placeholderText={placeholder}
        disabled={isDisabled}
        onKeyDown={e => {
          e.preventDefault();
        }}
        showMonthDropdown={showMonthDropdown}
        showYearDropdown={showYearDropdown}
        peekNextMonth
        dropdownMode="select"
        minDate={minDate}
        maxDate={maxDate}
        portalId={portalId}
        selectsRange={selectsRange}
        startDate={startDate}
        endDate={endDate}
        isClearable={isClearable}
      />
      <span className={`form-icon ${hasErrors && 'me-4'}`}>
        <FontAwesomeIcon icon="calendar-alt" />
      </span>
    </div>

  );
}
ReactYearPicker.defaultProps = {
  disabled: false,
  dateFormat: 'yyyy',
  hasErrors: false,
  showMonthDropdown: true,
  showYearDropdown: true,
};
